import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EparcoursPath } from '../../constantes/menu/menu-items/eparcours-path';
import { FacturationPath } from '../../pages/facturation/facturation-path';
import { NavService } from './nav-service';
import { PARAM_TOKEN } from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class FacturesNavService extends NavService {
  constructor(protected router: Router) {
    super(router);
  }

  edition_facture = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FACTURATION,
    FacturationPath.EDITION,
    PARAM_TOKEN,
    FacturationPath.GENERAL,
  );

  paiements = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FACTURATION,
    FacturationPath.EDITION,
    PARAM_TOKEN,
    FacturationPath.PAIEMENTS,
  );

  annulation_facture = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FACTURATION,
    FacturationPath.EDITION,
    PARAM_TOKEN,
    FacturationPath.GENERAL,
    FacturationPath.CANCEL_DIALOG,
  );
}
